
import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse} from '@angular/common/http';
import {finalize, of, throwError} from 'rxjs';
import {environment} from '@env/environment';
import {inject} from '@angular/core';
import {OdooService} from '@services/odoo.service';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {UtilsService} from '@services/utils.service';
import {ModalService} from '@services/modal.service';
import {AuthService} from '@services/auth.service';
import {PostError} from '../models/output.model';

export function AuthInterceptor(
  req: HttpRequest<unknown> ,
  next: HttpHandlerFn
) {
  const errorService = inject(ModalService);
  const utils = inject(UtilsService)
  const auth = inject(AuthService)
  utils.isLoading.set(true);

  const requestHandler =  handleMetaforaAuth(req, next)


  return requestHandler.pipe(
    switchMap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        const body = event.body as PostError;
        if (body) {
          if (body.error) {
            if (body.error.data.message.includes("401")) {
              return auth.getRefreshToken(req, next, body.error)
            } else if (body.message) {
              errorService.showMessage({message:body.message, statusText: ""});
            }
          }
        }
      }
      return of(event);
    }),
    catchError((body: HttpErrorResponse ) => {

      if (body.status === 401 || body.message.includes("401")) {
        return auth.getRefreshToken(req, next, body.error)
      } else {
        errorService.showMessage(body);
      }
      return throwError(() => body);
    }),
    finalize(() => {
      setTimeout(() => {
        utils.isLoading.set(false);
      }, 100);
    })
  );

}

function handleOdooAuth(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const odooService = inject(OdooService);
  //const token = odooService.sessionId();
        if (request.method === 'POST') {
          const cloned = request.clone( {
            setHeaders: {
              //'X-Openerp-Session-Id': token,
              'Content-Type': 'application/json'
            },
          //withCredentials: true
          });
          return next(cloned).pipe(finalize(() => {}));
        } else if (request.method === 'GET') {
          const cloned = request.clone(
            {setHeaders: {
                //'X-Openerp-Session-Id': token,
              }//,withCredentials: true
               });
          return next(cloned).pipe(finalize(() => {}));
        } else {
          return next(request.clone({
            //withCredentials: true
          }));
        }

}


function handleMetaforaAuth(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
  ) {
  const odooService = inject(OdooService);
  const token = odooService.sessionId();
        if (request.method === 'POST') {
          const cloned = request.clone({
            setHeaders: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/json'
            }
          });
          return next(cloned).pipe(finalize(() => {
          }));
        } else if (request.method === 'GET') {
          const cloned = request.clone({
            setHeaders: {
              'Authorization': 'Bearer ' + token,
            }
          });
          return next(cloned).pipe(finalize(() => {
          }));
        } else {
          return next(request);
        }
    }
